import {
    Box,
    Checkbox,
    Chip,
    FormControl,
    FormHelperText,
    Grid,
    Hidden,
    InputLabel,
    ListItemText,
    MenuItem,
    OutlinedInput,
    Select,
    Skeleton,
    Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';

function titleCase(str) {
    str = str.toLowerCase();
    return str.replace(/(^|\W)[a-z]/g, letter => {
        return letter.toUpperCase();
    });
}

export const TeacherMultiDropDown = props => {
    const [max6, setMax6] = useState(false);
    //const [error, setError] = useError

    useEffect(() => {
        console.log('props.teachers', props.teachers);
        console.log('props.selectedTeachers', props.selectedTeachers);

        props.teachers.filter(teacher => {
            return (
                teacher.firstName === props.teacherFirstName &&
                teacher.lastName === props.teacherLastName
            );
        });
    }, [props]);

    const handleTeacherChange = event => {
        console.log('remove', event.target.value);
        if (event.target.value.length === 5) {
            props.handleSelect(
                // On autofill we get a stringified value.
                typeof event.target.value === 'string'
                    ? event.target.value.split(',')
                    : event.target.value
            );
            setMax6(true);
        }
        if (event.target.value.length > 6) {
            setMax6(true);
        } else {
            props.handleSelect(
                // On autofill we get a stringified value.
                typeof event.target.value === 'string'
                    ? event.target.value.split(',')
                    : event.target.value
            );
            setMax6(false);
        }
    };

    return (
        <Grid
            container
            xs={12}
            sx={{
                marginTop: 1,
                marginBottom: 1,
                justifyContent: props.center ? 'center' : 'initial',
                alignItems: props.center ? 'center' : 'initial',
            }}
        >
            <Hidden only={['xs']}>
                <Grid item xs={12} sm={3} md={5}>
                    <Typography variant="h6">{props.title}</Typography>
                </Grid>
            </Hidden>
            <Grid item xs={12} sm={6} md={5}>
                {/* <TextField
                    select
                    id="teacher"
                    label={props.subtitle}
                    variant="outlined"
                    onChange={props.handleSelect}
                    sx={{ width: '100%' }}
                >
                    {props.teachers.map((teacher, index) => {
                        let indexItem = 'teacher' + index;
                        return (
                            <MenuItem key={teacher[props.compareValue]} value={teacher[props.compareValue]}>
                                {teacher.firstName + ' ' + teacher.lastName}
                            </MenuItem>
                        );
                    })}
                </TextField> */}
                {props.loadingStatus === 'succeeded' ? (
                    <FormControl sx={{ width: '100%' }}>
                        <InputLabel
                            id="demo-multiple-chip-label"
                            sx={{
                                'background-color': 'white',
                                paddingRight: '3px',
                            }}
                        >
                            {props.subtitle}
                        </InputLabel>

                        <Select
                            labelId="teacher-list"
                            id="demo-multiple-chip"
                            data-cy="select-teacher"
                            multiple
                            value={props.selectedTeachers}
                            onChange={handleTeacherChange}
                            input={
                                <OutlinedInput
                                    id="select-multiple-chip"
                                    label="Chip"
                                />
                            }
                            renderValue={selected => (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        gap: 0.5,
                                    }}
                                >
                                    {selected.map(value => (
                                        <Chip
                                            key={value}
                                            label={titleCase(
                                                props.teachers.filter(
                                                    teacherObject =>
                                                        teacherObject[
                                                            props.compareValue
                                                        ] === value
                                                )[0].firstName
                                            )}
                                        />
                                    ))}
                                </Box>
                            )}
                        >
                            {/* {props.loadingStatus === 'succeeded' ? (
                            <> */}
                            {props.teachers.map((teacher, index) => {
                                return (
                                    <MenuItem
                                        key={index}
                                        value={teacher[props.compareValue]}
                                        data-cy="teacher-checkbox"
                                    >
                                        <Checkbox
                                            checked={
                                                props.selectedTeachers.filter(
                                                    teacherObject =>
                                                        teacherObject ===
                                                        teacher[
                                                            props.compareValue
                                                        ]
                                                ).length > 0
                                            }
                                        />
                                        <ListItemText
                                            primary={
                                                titleCase(teacher.firstName) +
                                                ' ' +
                                                titleCase(teacher.lastName)
                                            }
                                        />
                                    </MenuItem>
                                );
                            })}
                            {/* </>
                        ) : (
                            <>
                                <MenuItem key={1} value="" disabled></MenuItem>
                                <ListItemText>
                                    {props.loadingStatus}
                                </ListItemText>
                            </>
                        )} */}
                        </Select>
                        <FormHelperText>
                            {max6 && 'Maximum 6 Teachers Selected'}
                        </FormHelperText>
                    </FormControl>
                ) : (
                    <>
                        {props.loadingStatus === 'failed' ? (
                            <Typography>
                                Failed to load school teachers
                            </Typography>
                        ) : (
                            <Skeleton height={65} />
                        )}
                    </>
                )}
                {/* <FormControl sx={{ m: 1, width: 300 }}>
                    <InputLabel id="demo-multiple-chip-label">Chip</InputLabel>
                    <Select
                    labelId="demo-multiple-chip-label"
                    id="demo-multiple-chip"
                    multiple
                    value={personName}
                    onChange={handleChange}
                    input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                    renderValue={(selected) => (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {selected.map((value) => (
                            <Chip key={value} label={value} />
                        ))}
                        </Box>
                    )}
                    MenuProps={MenuProps}
                    >
                    {names.map((name) => (
                        <MenuItem
                        key={name}
                        value={name}
                        style={getStyles(name, personName, theme)}
                        >
                        {name}
                        </MenuItem>
                    ))}
                    </Select>
                </FormControl> */}
            </Grid>
        </Grid>
    );
};

export default TeacherMultiDropDown;
